<template>
  <div class="car_rent">
    <div class="car_rent_nav">
      <img
        class="back"
        src="../../assets/carRent/reback@2x.png"
        @click="goBack"
      />
      汽车租赁
      <div class="title_r" @click="goOrder">租赁申请</div>
    </div>
    <div class="all">
      <div class="box">
        <div class="allDate">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="list.length != 0"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              ref="scroll"
            >
              <img
                class="banner"
                src="../../assets/carRent/car_rent_banner.jpg"
                @click="bannerDetail"
              />
              <van-cell
                class="lists"
                v-for="(item, index) in list"
                :key="index"
              >
                <van-row class="goods">
                  <van-col span="24" class="goods_info">
                    <img :src="item.images" @error="defaultPro()" />
                    <div class="mask" v-if="item.inventory == 0">已租完</div>
                    <div class="goods_r">
                      <p class="name">{{ item.name }}</p>
                      <p class="stock">
                        <span>可租车辆 {{ item.inventory }}辆</span>
                      </p>
                      <p class="money">指导价￥{{ item.guide_price }}</p>
                      <p
                        class="unit_price"
                        :class="{ noInventory: item.inventory == 0 }"
                      >
                        <span class="label_">￥</span>{{ item.daily_rent }}
                        <span class="dec">/日租价</span>
                        <btn
                          v-if="item.inventory != 0"
                          class="rent_btn"
                          :btntext="'申请'"
                          :btnwidth="'5rem'"
                          :height="'3rem'"
                          :bgcolor="'#EBF2FE'"
                          :borderradius="'0.4rem'"
                          :btncolor="'#236DFE'"
                          :fontsize="'1.2rem'"
                          :fontweight="700"
                          @btnClick="goDetail(item)"
                        />
                        <btn
                          v-if="item.inventory == 0"
                          class="rent_btn rent_btn_no_inventory"
                          :btntext="'申请'"
                          :btnwidth="'5rem'"
                          :height="'3rem'"
                          :bgcolor="'#EEEEEE'"
                          :borderradius="'0.4rem'"
                          :btncolor="'#666'"
                          :fontsize="'1.2rem'"
                          :fontweight="700"
                        />
                      </p>
                    </div>
                  </van-col>
                </van-row>
              </van-cell>
            </van-list>
          </van-pull-refresh>
          <van-row class="empty" v-if="list.length == 0 && !hasList">
            <van-col class="emptyMsg" span="24">
              <img src="../../assets/accountAgent/my/no_info.png" />
              <p class="tip">暂无订单</p>
            </van-col>
          </van-row>
          <div class="loading" v-if="list.length <= 0 && hasList">
            <img src="../../assets/accountAgent/common/loading.gif" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import btn from "../purchaseSupplier/components/button.vue";
import productDefault from "@/assets/common/preload.png";
export default {
  components: {
    btn,
  },
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      hasList: true,
    };
  },
  created() {
    this.getInfo();
  },
  mounted() {
    document
      .querySelector(".box")
      .addEventListener("scroll", this.handleScroll);
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  methods: {
    goBack() {
      this.params("", "", "goBack");
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
      this.$refs.scroll.scrollTop = 0;
    },
    getInfo() {
      this.$api
        .post("/ongoods/member/car-goods/list", {
          page: 1,
          pageSize: 50,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.total <= 0) {
            this.hasList = false;
          }
          if (res.list.length > 0) {
            for (let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          this.hasList = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
        });
    },
    goOrder() {
      this.$router.push("/carRent/orderList");
    },
    goDetail(item) {
      this.$router.push({
        path: "/carRent/carDetail",
        query: {
          id: item.id,
        },
      });
    },
    defaultPro() {
      var img = event.srcElement;
      img.src = productDefault;
      img.onerror = null; //防止闪图
    },
    bannerDetail() {
      this.$router.push("/carRent/bannerDetail");
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.car_rent {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .car_rent_nav {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 3;
    height: 8.8rem;
    padding: 4.4rem 1.2rem 0;
    box-sizing: border-box;
    background: #fff;
    color: #333;
    font-weight: 700;
    font-size: 1.7rem;
    text-align: center;
    line-height: 4.4rem;

    img {
      position: absolute;
      bottom: 1rem;
      left: 1.2rem;
      width: 2.4rem;
    }

    .title_r {
      position: absolute;
      bottom: 0.7rem;
      right: 1.2rem;
      font-size: 1.4rem;
      line-height: 2.8rem;
    }
  }

  .all {
    padding: 10rem 1.2rem 0;
    box-sizing: border-box;
    height: 100%;

    .box {
      height: 100%;
      .allDate {
        background-color: #f5f6f7;
        height: 100%;

        .empty {
          padding-top: 10rem;

          .emptyMsg {
            text-align: center;

            img {
              width: 22.1rem;
              display: inline-block;
            }

            .tip {
              color: #cccccc;
              font-size: 1.4rem;
              margin-top: 1.7rem;
              height: 2rem;
              line-height: 2rem;
            }
          }
        }

        .loading {
          width: 100%;
          /*padding-top: 100px;*/
          text-align: center;

          img {
            width: 35%;
            margin-top: 50%;
          }
        }

        .van-pull-refresh {
          height: 100%;
          box-sizing: border-box;
          overflow-y: scroll;
          -webkit-overflow-scrolling: touch;

          .banner {
            width: 100%;
            margin-bottom: 1.2rem;
            border-radius: 0.8rem;
          }

          .lists {
            border-radius: 0.8rem;
            padding: 0;
            margin-bottom: 1.2rem;

            .goods {
              height: 13.5rem;
              border-radius: 0.8rem;
              background: #fff;
              padding: 0;

              .goods_info {
                padding: 1.4rem 1.4rem 0.6rem;
                box-sizing: border-box;
                position: relative;

                img {
                  position: absolute;
                  top: 1.4rem;
                  left: 1.4rem;
                  width: 10.7rem;
                  height: 8.1rem;
                  border-radius: 0.6rem;
                }

                .mask {
                  position: absolute;
                  top: 1.4rem;
                  left: 1.4rem;
                  z-index: 3;
                  width: 10.7rem;
                  height: 8.1rem;
                  line-height: 8.1rem;
                  border-radius: 0.6rem;
                  text-align: center;
                  color: #fff;
                  font-size: 1.4rem;
                  font-weight: 700;
                  background: rgba(0, 0, 0, 0.39);
                }

                .rent_btn {
                  position: absolute;
                  bottom: 0.6rem;
                  right: 1.4rem;
                }

                .goods_r {
                  padding-left: 11.7rem;

                  .name {
                    font-size: 1.6rem;
                    color: #000;
                    font-weight: 700;
                    height: 4.4rem;
                    line-height: 2.2rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    white-space: normal;
                  }

                  .stock {
                    height: 1.8rem;
                    margin: 0.4rem 0 0.6rem;

                    span {
                      color: #333;
                      height: 1.6rem;
                      line-height: 1.6rem;
                      font-size: 1rem;
                      font-weight: 700;
                      border: solid 1px #c8c8c8;
                      border-top-left-radius: 0.4rem;
                      border-bottom-right-radius: 0.4rem;
                      padding: 0 0.5rem;
                    }
                  }

                  .money {
                    color: #999;
                    font-size: 1.2rem;
                    line-height: 1.7rem;
                    margin-bottom: 0.4rem;
                    font-weight: 700;
                  }

                  .unit_price {
                    color: #ff4747;
                    font-size: 1.6rem;
                    font-weight: 700;
                    line-height: 2.2rem;

                    .label_ {
                      font-size: 1rem;
                    }

                    .dec {
                      color: #999;
                      font-size: 1rem;
                    }
                  }

                  .noInventory {
                    color: #999;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>




